import { RiAlertLine, RiArrowLeftLine } from "@remixicon/react";
import { Button } from "@workspace/ui/components/button";
import { Card } from "@workspace/ui/components/card";
import { useRouter } from "next/navigation";

interface ShowErrorStateProps {
	message?: string;
	showBackButton?: boolean;
}

export function ShowErrorState({
	message = "The show you're looking for could not be found.",
	showBackButton = true,
}: ShowErrorStateProps) {
	const router = useRouter();

	return (
		<div className="container mx-auto max-w-3xl px-4 py-6">
			<Card className="p-8 text-center">
				<div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
					<RiAlertLine className="h-6 w-6 text-muted-foreground" />
				</div>

				<h3 className="mb-1 font-semibold text-xl">Show Not Found</h3>
				<p className="mb-6 text-muted-foreground text-sm">{message}</p>

				{showBackButton && (
					<Button
						variant="outline"
						onClick={() => router.back()}
						className="gap-2"
					>
						<RiArrowLeftLine className="h-4 w-4" />
						Go Back
					</Button>
				)}
			</Card>
		</div>
	);
}
